import {useEffect, useState} from "react";
import {useAuth0} from "@auth0/auth0-react";

import {userProfileService} from "../../service/userProfile/userProfile.service";
import {SENSITIVE_SCOPE} from "../../config/securityContext";

import Spinner from "../../helpers/spinner";
import DynamicAlert from "../../helpers/dynamicAlert";
import {useLocation, useNavigate} from "react-router-dom";

export default function PostLoginHandler() {
    const {isAuthenticated} = useAuth0();
    const location = useLocation();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [alert, setAlert] = useState(null);

    const pendingOperationJson = sessionStorage.getItem("pendingOperation");

    const pendingOperation = pendingOperationJson ? JSON.parse(pendingOperationJson) : null;
    useEffect(() => {
        const run = async () => {
            if (!isAuthenticated) return;

            const returnTo = location.pathname || "/account-settings";

            if (!pendingOperation) {
                navigate(returnTo, {replace: true});
                return;
            }

            try {
                setIsLoading(true);
                sessionStorage.removeItem(
                    "pendingOperation"
                );
                const scope = pendingOperation.scope;
                switch (scope) {
                    case SENSITIVE_SCOPE.CHANGE_PASSWORD: {
                        const res = await userProfileService.resetPasswordTicket(scope);
                        if (res?.ticket) {
                            window.location.href = res.ticket;
                        }

                        break;
                    }

                    case SENSITIVE_SCOPE.DELETE_ACCOUNT: {
                        const res = await userProfileService.deleteProfile(scope);
                        console.log("Delete response:", res);

                        navigate("/delete/profile", {
                            replace: true,
                            state: {
                                action: res.statusCode ==="500"?"deletion-failed":"deleted-account"
                            }
                        });

                        break;
                    }

                    default:
                        navigate(returnTo, {
                            replace: true,
                        });
                }
            } catch
                (error) {
                console.error("PostLoginHandler error:", error);
                setAlert({
                    id: Date.now(),
                    type: "danger",
                    msg: "Something went wrong while processing your request.",
                });
            } finally {
                setIsLoading(false);
            }
        };

        run();
    }, [isAuthenticated, location.pathname, navigate, pendingOperation]);

    return (
        <>
            <DynamicAlert alert={alert}/>
            {isLoading && <Spinner/>}

        </>
    );
}